import { CloseOutlined } from "@ant-design/icons"
import { Modal } from "antd"
import { Copy, requestMail } from "../ExportImgFigma"
import './style.scss'
import { useState } from "react"
import useToast from "../../hook/useToast"
interface ModalProps {
  isOpen: boolean
  title: string
  content: string
  closeModal: () => void
}

export const ModalPermissionLogin: React.FC<ModalProps> = ({
  isOpen, title, content,
  closeModal
}) => {
  const pushToast = useToast()

  const handleCopy = () => {
    pushToast("Đã sao chép", "success")
    navigator.clipboard.writeText("Support-thaco@thaco.com.vn")
  }
  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">{title}</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal modal-content-warning ant-modal-size"
      closeIcon={false}
      footer={false}
    >
      <div className="p-6 d-flex flex-column justify-center align-center gap-18-px">
        <img src={requestMail} alt="warning" className="w-110-px h-110-px" />
        <span className="text-base font-regular fw-700 text-344054 text-center">Tài khoản của bạn hiện chưa được cấp quyền truy cập vào hệ thống. Vui lòng liên hệ Quản trị viên để được hỗ trợ cấp quyền.</span>
        {/* <div className="w-full px-4 py-10-px rounded-4 shadow-btn-permission d-flex justify-between align-center">
          <span className="text-sm font-regular fw-400 text-096DD9">Support-thaco@thaco.com.vn</span>
          <button className="bg-FF891A rounded-4 p-2 d-flex align-center gap-6-px border-none"
            onClick={handleCopy}
          >
            <img src={Copy} alt="" />
            <span className="text-sm text-white">Copy email</span>
          </button>
        </div> */}
      </div>
    </Modal>
  )
}
